/**
 * @author sudong.duan
 * Date: 21-12-16
 * desc: 公共方法
 */

/**
 *判断是否为空
 *@param {String}a 变量
 *@return 是否为空
 */
const isEmpty = function (a) {
	if (a === undefined || a === 'undefined' || a === null || a === 'null' || a === '' || JSON.stringify(a) === '{}' || JSON.stringify(a) === '[]') {
		return true
	}
	return false
}


/**
	判断是否微信环境
	@param 
	@return { Boolean } 是否微信环境
*/
function is_weixin() {
	var ua = navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == "micromessenger") {
		return true;
	} else {
		return false;
	}
}

/**
 节流函数
 @param {Function} callback 回调函数
 @return
 */
const throttleFnc = function (callback) {
	let isLimit = false
	// tslint: disable 
	return function () {
		if (!isLimit) {
			isLimit = true
			// @ts-ignore #
			callback.call(this, function () {
				isLimit = false
				// @ts-ignore #
			}, ...arguments)
		}
	}
}

/**
 获取浏览器环境
 @param 
 @return { String } 浏览器环境
 */
const  getENV = ()=> {
	const ua = navigator.userAgent.toLowerCase();
	const isWeixin = ua.indexOf('micromessenger') !== -1;
	const isInApp = /(^|;\s)app\//.test(ua);
	if (isWeixin) {
		if (window.__wxjs_environment === 'miniprogram') {
			return 'wxapp';
		} else {
			return 'wxh5';
		}
	} else {
		if (!isInApp) {
			return 'browser';
		} else {
			if (ua.match(/(iphone|ipod|ipad);?/i)) {
				return 'ios'
			}
			if (ua.match(/android|adr/i)) {
				return 'android'
			}
			return 'browser'
		}
	}
}

/**
	获取requestClient
	@param 
	@return {String} requestClient
*/
const getRequestClient = () => {
	const env = getENV()
	switch (env) {
		case 'wxapp':
			return 1
		default: 
			return 1
	}
}

/**
	过滤填空题数据
	@param {String} text 待处理的填空题数据
	@return {String} 已处理的填空题数据
*/
const filterFillBlankText = (text) => {
	return text.split('').map((char, charIndex) => {
		if (charIndex > 0 && char === '_' && text[charIndex - 1] === '_') {
			return ''
		} else {
			return char
		}
	}).join('').replace(/_/g, '@@@###@@@')

}


export {
	isEmpty,
	is_weixin,
	throttleFnc,
	getENV,
	getRequestClient,
	filterFillBlankText
}


// WEBPACK FOOTER //
// ./src/utils/common.js